import FocusableBackButton from '@components/FocusableBackButton';
import FocusableIconButton from '@components/FocusableIconButton';
import Loading from '@components/Loading';
import { usePostPaymentContext } from '@context/Payment/PostPayment';
import { FocusContext, useFocusable } from '@noriginmedia/norigin-spatial-navigation';
import { useEffect } from 'react';

import PaymentButton from '../../../components/PaymentButton';
import { generatePostPaymentMethodFocusKey, POST_PAYMENT_METHOD_NEW } from '../focusKey';

import * as styles from './styles';

const PostPaymentView = () => {
  const {
    isPrescriptionExists,
    paymentMethods,
    postPaymentFee,
    setButtonFocus,
    loaderVisible,
    openTryPostPaymentModal,
    goPaymentRegistration
  } = usePostPaymentContext();

  const { focusKey } = useFocusable();

  useEffect(() => {
    setButtonFocus();
  }, [setButtonFocus]);

  return (
    <FocusContext.Provider value={focusKey}>
      <div css={styles.container}>
        <div css={styles.mainContainer}>
          <FocusableBackButton />
          <div css={styles.title}>진료비 결제</div>
          <div css={styles.content}>결제할 금액</div>
          <div css={styles.subContent}>{`${postPaymentFee}원`}</div>
          <div css={styles.description}>
            {isPrescriptionExists ? '진료비를 결제한 다음' : '진료비 청구서가 도착했어요'}
            <br />
            {isPrescriptionExists ? '처방전을 확인할 수 있어요.' : '진료비를 결제해 주세요.'}
          </div>
        </div>
        <div css={styles.rightContainer}>
          <div css={styles.subtitle}>등록된 결제 수단</div>
          <div css={styles.rightButtonContainer}>
            {paymentMethods.map((paymentMethod, index) => (
              <PaymentButton
                key={index}
                paymentMethod={paymentMethod}
                focusKey={generatePostPaymentMethodFocusKey(index)}
                onEnterPress={() => openTryPostPaymentModal(paymentMethod)}
              />
            ))}
            <FocusableIconButton
              focusKey={POST_PAYMENT_METHOD_NEW}
              onEnterPress={goPaymentRegistration}
              iconType="plus"
            >
              새로운 결제수단 등록하기
            </FocusableIconButton>
          </div>
        </div>
      </div>
      <Loading visible={loaderVisible} />
    </FocusContext.Provider>
  );
};

export default PostPaymentView;
